import './components/SearchHooks';
import './components/wc-products/frontend';
import './blocks/results-block/frontend';
import Personalization from './components/Personalization';

const personalization = new Personalization();
personalization.init();
